import { render, staticRenderFns } from "./questionnaireResultDetail.vue?vue&type=template&id=572a3dbe&scoped=true"
import script from "./questionnaireResultDetail.vue?vue&type=script&lang=js"
export * from "./questionnaireResultDetail.vue?vue&type=script&lang=js"
import style0 from "./questionnaireResultDetail.vue?vue&type=style&index=0&id=572a3dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a3dbe",
  null
  
)

export default component.exports